"use client";
const t = "data-composite-item-active";
export {
  t as A
};
